import { DeploymentRequestDetail } from "../../services/deployment-request";
import {
  EdhNotificationType,
  GeneralCode,
  Interface,
} from "../interface-definitions";

export type Option = { label: string; value: string };

export type DeploymentRequestDetailPageState = {
  deploymentRequestDetail: DeploymentRequestDetail;
  formValidation: FormValidation;
  tckIdList: TckId[];
  deploySchedule: {
    type: string;
    date: string;
    hour: string;
    minutes: string;
  };
  ifList: Interface[];
  generalCode: GeneralCode;
  edhNotificationType: EdhNotificationType;
  displayColumn: Option[];
  fieldPath: { reviewComment: string };
  authorized: boolean;
};

export type FormValidation = {
  rvwCmnt: boolean;
};

export type TckId = {
  tckId: string;
};

export type PageNewState =
  | DeploymentRequestDetailPageState
  | ((
      prevState: DeploymentRequestDetailPageState,
    ) => DeploymentRequestDetailPageState);
